import React from 'react';
import { useLocation } from 'react-router-dom';

const routeStyles: Record<string, string> = {
  '/': 'from-[#090909] via-[#1b120f] to-[#20130b]',
  '/projects': 'from-[#080808] via-[#151515] to-[#24120a]',
  '/contact': 'from-[#070707] via-[#111111] to-[#1b0f08]',
};

export default function VisualLayer() {
  const location = useLocation();
  const gradient = routeStyles[location.pathname] ?? routeStyles['/'];

  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 overflow-hidden">
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} transition-all duration-700`} />
      <div className="absolute inset-0 opacity-40 [background-image:linear-gradient(rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.06)_1px,transparent_1px)] [background-size:84px_84px] [mask-image:radial-gradient(circle_at_center,black,transparent_78%)]" />
      <div className="absolute left-[-12rem] top-[-10rem] h-[28rem] w-[28rem] rounded-full bg-neonOrange/15 blur-3xl animate-float-slow" />
      <div className="absolute bottom-[-14rem] right-[-10rem] h-[30rem] w-[30rem] rounded-full bg-gold/10 blur-3xl animate-float-delayed" />
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black/50 to-transparent" />
    </div>
  );
}
